import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';

export enum InterestCategory {
    Sport = 'sport',
    Food = 'food',
    Leisure = 'leisure',
    Culture = 'culture',
    Camping = 'camping'
}


@CwtModel({ name: 'interest', path: '/interest' })
export class Interest extends ApiData {
    name?: DictionaryObject;
    category?: InterestCategory;
}
